<template>
  <div class="mainContainer">
    <div class="nav">
      <div class="navContainer" style="width: 230px">
        <p>仓库名称：</p>
        <el-input v-model="nameIpt" size="mini" style="width:150px" placeholder="请输入公司全称"/>
      </div>
      <div class="navContainer" style="width: 230px">
        <p>任务编号：</p>
        <el-input v-model="numIpt" size="mini" style="width:150px" placeholder="请输入任务编号"/>
      </div>
      <div class="navContainer" style="width: 480px">
        <p>出库时间：</p>
        <el-date-picker
          v-model="time"
          size="mini"
          type="datetimerange"
          range-separator="至"
          start-placeholder="开始日期"
          end-placeholder="结束日期"/>
      </div>
      <div class="navContainer" style="width: 240px">
        <p>运输托运商：</p>
        <el-select v-model="areaIpt" filterable size="mini" style="width:150px" placeholder="请选择运输托运商">
          <el-option v-for="item in areaOption" :key="item.label" :label="item.label" :value="item.value"/>
        </el-select>
      </div>
      <div class="navBtn">
        <el-button size="small" class="searchBtn" @click="searchBtn">查询</el-button>
        <el-button size="small" class="resetBtn" @click="resetBtn">重置</el-button>
        <el-button size="small" type="primary" @click="addBtn">新增</el-button>
      </div>
    </div>
    <div class="content">
      <div class="tableContainer">
        <el-table
          v-loading="tableLoad"
          :data="TableDatas"
          style="width: 100%"
          border
          stripe
           :header-cell-style="{color:'#3B3B3B','font-size':'13px','height':'48px',background:'#E8E8E8'}"
          :cell-style="{'color':'#7F7F7F','font-size':'13px','height':'52px',}"
        >
          <el-table-column label="序号" align="center" width="50px">
            <div slot-scope="scope">{{scope.$index+1}}</div>
          </el-table-column>
          <el-table-column prop="name" label="仓库名称" align="center"/>
          <el-table-column prop="num" label="任务编号" align="center"/>
          <el-table-column prop="start" label="起运地址" align="center"/>
          <el-table-column prop="address" label="交车地址" width="199" align="center"/>
          <el-table-column prop="time" label="装车时间" align="center"/>
          <el-table-column prop="team" label="分配车队" align="center"/>
          <el-table-column prop="distribution" label="是否分配车辆" align="center"/>
          <el-table-column label="操作" width="210" align="center">
            <template slot-scope="scope">
              <div>
                <el-button v-if="scope.row.state==='启用中'" size="mini" type="danger" @click="disableClick(scope.$index, scope.row)">禁用</el-button>
                <el-button v-else size="mini" type="primary" @click="enableClick(scope.$index, scope.row)">启用</el-button>
                <el-button size="mini" class="searchBtn" type="primary" @click="detailClick(scope.$index, scope.row)">详情</el-button>
                <el-button size="mini" type="primary" @click="changeClick(scope.$index, scope.row)" class="yellow-bg">修改</el-button>
              </div>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <div class="paginationContainer">
        <span>共{{total}}条</span>
        <el-pagination
          background
          :page-sizes="[10, 20, 30, 40]"
          layout="sizes,prev, pager, next,jumper"
          :total="total"
          @size-change="contractSizeChange"
          @current-change="contractCurrentChange"
          @prev-click="contractCurrentChange"
          @next-click="contractCurrentChange"
        />
      </div>
    </div>
    <el-dialog title="详情仓库" :visible.sync="detailDialogVisible" width='550px' center>
      <div class="detail">
        <div class="baseInfo">
          <div class="baseInfoTitle">
            <div class="line"/>
            <span>基础信息</span>
            <p>{{detailData.state}}</p>
          </div>
          <div class="baseInfoContent">
            <div class="baseInfoContentItem">
              <span class="span1">仓库名称：</span>
              <span>{{detailData.warehouse}}</span>
            </div>
            <div class="baseInfoContentItem">
              <span class="span1">所在区域：</span>
              <span>{{detailData.area}}</span>
            </div>
            <div class="baseInfoContentItem">
              <span class="span1">详细地址：</span>
              <span>{{detailData.address}}</span>
            </div>
            <div class="baseInfoContentItem">
              <span class="span1">免费停放{{detailData.free}}{{detailData.unit}}，超时按每1{{detailData.unit2}}收取{{detailData.price}}元</span>
            </div>
          </div>
        </div>
        <div class="operation">
          <div class="operationTitle">
            <div class="line"/>
            <span>操作信息</span>
          </div>
          <div class="operationTable">
            <el-table :data="operationData" border>
              <el-table-column prop="operateTime" label="操作时间" align="center" width="160px"/>
              <el-table-column prop="operateType" label="操作类型" align="center"/>
              <el-table-column prop="account" label="操作人" align="center"/>
              <el-table-column prop="remark" label="备注" align="center"/>
            </el-table>
          </div>
        </div>
      </div>
    </el-dialog>
    <el-dialog :title="dialogTitle" :visible.sync="dialogVisible" width='550px' center @close="dialogClose" :close-on-click-modal="false">
      <div class="company">
        <el-form :model="companyData" label-width="95px" :rules="rules" ref="ruleForm">
          <el-form-item label="仓库名称：" prop="warehouse">
            <el-input
              :style="'width:100%'"
              v-model="companyData.warehouse"
              placeholder="请输入仓库名称"
              autocomplete="off"
              size="small"
            />
            <hr color="#F0F0F2"/>
          </el-form-item>
          <el-form-item label="所在地址：" prop="address">
            <el-select v-model="companyData.address" filterable size="mini" style="width:100%" placeholder="请选择所在地址">
              <el-option v-for="item in areaOption1" :key="item.label" :label="item.label" :value="item.value"/>
            </el-select>
            <hr color="#F0F0F2"/>
          </el-form-item>
          <el-form-item label="免费停放：" prop="free">
            <div class="unitContainer">
              <el-input
                :style="'width:70px'"
                v-model="companyData.free"
                autocomplete="off"
                size="mini"
              />
              <el-select v-model="companyData.unit" filterable size="mini" style="width:60px">
                <el-option v-for="item in unitOption" :key="item.label" :label="item.label" :value="item.value"/>
              </el-select>
            </div>
            <hr color="#F0F0F2"/>
          </el-form-item>
          <el-form-item label="超时按每：" prop="price">
            <div class="unitContainer2">
              <el-select v-model="companyData.unit2" filterable size="mini" style="width:60px">
                <el-option v-for="item in unitOption" :key="item.label" :label="item.label" :value="item.value"/>
              </el-select>
              <span>收取</span>
              <el-input
                :style="'width:70px'"
                v-model="companyData.price"
                autocomplete="off"
                size="mini"
              />
              <span>元</span>
            </div>
            <hr color="#F0F0F2"/>
          </el-form-item>
          <div class="btnContainer">
            <el-button size="medium" class="searchBtn" :loading="addLoad" @click="addClick">确认</el-button>
            <el-button size="medium" class="resetBtn" @click="dialogClose">关闭</el-button>
          </div>
        </el-form>
      </div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  components: {
  },
  data() {
    return {
      nameIpt:'',
      numIpt:'',
      time:'',
      areaIpt:0,
      areaOption:[
        {value:0,label:'全部',},
        {value:'车队1',label:'车队1'},
        {value:'车队2',label:'车队2'},
      ],
      page:1,
      size:10,
      total:0,
      tableLoad:false,
      TableDatas:[
        {name:'仓库1',num:'RW20215453',start:'重庆市渝北区xxx',address:'重庆市渝北区xxx',time:'2021-10-9 11:21:16',team:'车队1、车队2',distribution:'否',},
      ],
      detailDialogVisible:false,
      addLoad:false,
      detailData:{state:'启动中',warehouse:'123123123',area:'重庆市-渝北区',address:'重庆市渝北区xxxxxxxxxx',free:'3',unit:'天',price:'10',unit2:'时',},
      operationData:[
        {operateTime:'2021-8-31 15:49:58',operateType:'启用',account:'王三文',remark:''},
        {operateTime:'2021-8-31 15:49:58',operateType:'禁用',account:'张三丰',remark:''},
        {operateTime:'2021-8-31 15:49:58',operateType:'添加',account:'赵兮雪',remark:''},
      ],
      dialogTitle:'',
      dialogVisible:false,
      companyData:{
        warehouse:'',
        address:'',
        free:'',
        unit:0,
        price:'',
        unit2:0,
      },
      areaOption1:[
        {value:'重庆市-渝北区',label:'重庆市-渝北区'},
        {value:'重庆市-九龙坡区',label:'重庆市-九龙坡区'},
      ],
      unitOption:[
        {value:0,label:'天'},
        {value:1,label:'时'},
      ],
      rules:{
        warehouse:[
          { required: true, message: '请输入仓库名字', trigger: 'blur' },
        ],
        address:[
          { required: true, message: '请选择所在地址', trigger: 'change' },
        ],
        free:[
          { required: true, message: '请选择免费停放时间', trigger: 'change' },
        ],
        price:[
          { required: true, message: '请选择超时收费标准', trigger: 'change' },
        ],
      },
    };
  },
  methods: {
    contractSizeChange(sizes){
      this.size=sizes;
    },
    contractCurrentChange(page){
      this.page=page;
    },
    disableClick(){
      this.$confirm('确定要禁用当前仓库吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
      }).catch(() => {});
    },
    detailClick(){
      this.detailDialogVisible=true;
    },
    changeClick(){
      this.companyData={
        warehouse:'123123',
        address:'重庆市-渝北区',
        free:'2',
        unit:0,
        price:'4',
        unit2:0,
      };
      this.dialogTitle='修改仓库';
      this.dialogVisible=true;
    },
    searchBtn(){
      this.page = 1;
    },
    resetBtn(){
      this.nameIpt='';
      this.time='';
      this.numIpt='';
      this.areaIpt=0;
    },
    addBtn(){
      this.dialogTitle='添加仓库';
      this.dialogVisible=true;
      this.companyData={
        warehouse:'',
        address:'',
        free:'',
        unit:0,
        price:'',
        unit2:0,
      };
    },
    addClick(){
      this.$refs.ruleForm.validate((valid) => {
        if (valid) {
          this.addLoad = true;
          this.addLoad = false;
          this.dialogVisible=false;
        } else {
          return false;
        }
      });
    },
    enableClick(){
      this.$confirm('确定要启用当前仓库吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
      }).catch(() => {});
    },
    dialogClose(){
      this.dialogVisible=false;
      this.$refs.ruleForm.resetFields();
    },
  },
};
</script>



<style lang="scss" scoped>
.mainContainer{
  width:100%;
  padding:20px 15px 0 25px;
  background-color: #fff;
  .line{
    width: 12px;
    height: 32px;
    background-color: rgba(51, 84, 131, 100);
    margin-right: 10px;
  }
  .line +span{
    font-size: 16px;
    color: rgba(51, 84, 131, 100);
    font-weight: 600;
  }
  .nav{
    width:100%;
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    ::v-deep {
      label.el-form-item__label {
        font-weight: 500;
        color: #101010;
      }
    }
    &Container{
      width:200px;
      display: flex;
      align-items: center;
      margin-right: 5px;
      margin-bottom: 5px;
      p{
        font-size: 14px;
        color: rgba(16, 16, 16, 100);
      }
    }
    &Btn{
      display: flex;
      align-items: center;
      margin-bottom: 5px;
    }
  }
  .content{
    display: flex;
    flex-direction: column;
    align-items: center;
    .tableContainer{
      margin-top: 30px;
      margin-bottom: 25px;
      width: 100%;
      ::v-deep{
        .el-table .cell {
          padding: 0;
        }
        .el-table th{
          padding: 0;
        }
        .el-table td{
          padding: 0;
        }
      }
    }
    .paginationContainer{
      margin-right: auto;
      display: flex;
      align-items: center;
      margin-bottom: 20px;
      span{
        font-size: 13px;
      }
    }
  }
  .detail{
    width: 100%;
    padding: 10px 0 20px 20px;
    .baseInfo{
      display: flex;
      flex-direction: column;
      &Title{
        display:flex;
        align-items:flex-end;
        p{
          font-weight: 700;
          font-size: 14px;
          color: rgba(51, 136, 255, 1);
          margin-left: 10px;
        }
      }
      &Content{
        display:flex;
        flex-direction: column;
        justify-content: space-between;
        padding:20px 23px 0 23px;
        &Item{
          margin-bottom: 20px;
          .span1{
            font-weight: 700;
          }
          span{
            font-size: 14px;
          }
          .specialOne{
            width:50%;
          }
        }
        .specialItem{
          display:flex;
        }
      }
    }
    .operation{
      display: flex;
      flex-direction: column;
      ::v-deep{
        .el-table td, .el-table th{
          padding:0;
        }
        .cell{
          font-size: 10px;
          padding:0;
        }
      }
      &Title{
        display:flex;
        align-items:flex-end;
        p{
          font-weight: 700;
          font-size: 14px;
          color: rgba(51, 136, 255, 1);
          margin-left: 10px;
        }
      }
      &Table{
        width:100%;
        margin-top: 10px;
        padding: 0 20px;
      }
    }
  }
  .company{
    width:100%;
    padding: 20px 10px;
    .unitContainer{
      display: flex;
      align-items:center;
      justify-content:space-between;
      width:140px;
      margin-bottom:5px;
      ::v-deep{
        .el-input__inner{
          border: 1px solid #DCDFE6;
        }
      }
    }
    .unitContainer2{
      display: flex;
      align-items:center;
      justify-content:space-between;
      width:189px;
      margin-bottom:5px;
      span{
        color: #606266;
        font-weight: 700;
      }
      ::v-deep{
        .el-input__inner{
          border: 1px solid #DCDFE6;
        }
      }
    }
    ::v-deep{
      .el-form-item__label{
        font-weight: 700;
      }
      .el-input__inner{
        border: none;
      }
      .el-form-item__label{
        padding:0;
      }
      .el-form-item__content{
        position: relative;
      }
    }
    hr{
      margin: 0;
      position: absolute;
      width: 100%;
      bottom: 5px;
    }
    .btnContainer{
      width:100%;
      display: flex;
      align-items: center;
      justify-content: center;
      margin-bottom: 20px;
      button{
        margin: 0 15px;
      }
    }
  }
  ::v-deep{
    .el-table th>.cell{
      font-weight: 700!important;
    }
  }
}
::v-deep{
  .el-dialog__header {
    padding: 9px 20px 9px;
    background: #335483;
  }
  .el-dialog__title {
    line-height: 24px;
    font-size: 14px;
    color: #FFFFFF;
  }
  .el-dialog__headerbtn{
    top:9px;
  }
  .el-dialog__headerbtn .el-dialog__close {
    color: #fff;
    font-size: 25px;
  }
  .el-dialog__body {
    padding: 0;
  }
}
</style>
